import { Bus, useAside, useNotif } from '@orion.ui/orion';
import OrganizationUserApi from '@/api/OrganizationUserApi';
import UserApi from '@/api/UserApi';
import OrganizationUserAsideNew from '@/components/organization-user/OrganizationUserAsideNew.vue';

class OrganizationUserService implements ResourceService {
	private get api () { return OrganizationUserApi; }

	async storeAsync (payload: IAddOrganizationUserModel) {
		await this.api.add(payload);
		Bus.emit('OrganizationUserPagedListViewSetupService:refresh-list', true);
	}

	async getAsync (/* id: number */) {
		throw new Error('Method not implemented.');
	}

	async gridAsync (...args: Parameters<typeof OrganizationUserApi.grid>) {
		return await this.api.grid(...args);
	}

	async updateAsync (/* id: number, payload: any */) {
		throw new Error('Method not implemented.');
	}

	async deleteAsync (id: number) {
		try {
			await this.api.delete(id);
			useNotif.success(`Utilisateur supprimé avec succès`);
			Bus.emit('OrganizationUserPagedListViewSetupService:refresh-list');
		} catch (error: any) {
			useNotif.danger(error?.response?.data);
		}
	}

	async sendActivationMailAsync (userId: number) {
		try {
			await UserApi.sendEmailActivation(userId);
			useNotif.success(`Email envoyé avec succès`);
		} catch (error) {
			useNotif.danger(`Oops, il y a eu un problème`);
		}
	}

	async promptNewOrganizationUserAsync () {
		useAside({ Nested: OrganizationUserAsideNew });
	}
}

export default function useOrganizationUserService () {
	return new OrganizationUserService();
}
